// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonMarkdownEditor = {
  emptyPreview: "No markdown content yet",
  modes: {
    edit: "Edit",
    split: "Split",
    preview: "Preview",
  },
  toolbar: {
    heading: "Heading",
    bold: "Bold",
    italic: "Italic",
    quote: "Quote",
    bulletList: "Bullet List",
    orderedList: "Ordered List",
    link: "Link",
    codeBlock: "Code Block",
  },
  placeholders: {
    heading: "Section title",
    bold: "bold text",
    italic: "italic text",
    quote: "Quoted note",
    bulletList: "List item",
    orderedList: "Ordered item",
    link: "Link text",
    codeBlock: "code block",
  },
} as const;
